import styled from "styled-components"

const Wrapper = styled.div`
  border-radius: 3px;
  box-shadow: 0 0 3px 0 rgba(61, 61, 54, 0.2), 0 3px 2px 2px rgba(61, 61, 54, 0.15);
  list-style-type: none;
  margin-left: -2px;
  margin-top: -2px;
  width: calc(100% + 4px);
`

export default Wrapper
